export default __webpack_public_path__ + "static/assets/fonts/1dd95326da7ee223337831e698640603.eot";